import React from 'react'
import {Navigate} from 'react-router-dom'
import {useAuthentication} from 'components/providers/AuthenticationProvider'

const UnauthenticatedRoute = ({component: C}) => {
  const {isAuthenticated} = useAuthentication()
  return isAuthenticated ? <Navigate to="/" /> : <C />
}

export default UnauthenticatedRoute
